import './styles/forfeo-a3-essential-fixes.css';
import { initForfeoA3EssentialRuntime } from './lib/forfeoA3EssentialRuntime';
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'; // On utilise BrowserRouter pour des URLs propres
import App from './App.tsx'
import Forfeo2026RouteSkin from './components/design/Forfeo2026RouteSkin';
import AppUpdateBanner from './components/AppUpdateBanner'
import './index.css'
import './i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Forfeo2026RouteSkin />
      <App />
      <AppUpdateBanner />
    </BrowserRouter>
  </React.StrictMode>,
)

// ==========================================
// CONFIGURATION PWA (APPLICATION MOBILE)
// ==========================================
// Enregistrement du Service Worker pour permettre l'installation sur l'écran d'accueil
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => {
        console.log('✅ Service Worker Forfeo enregistré avec succès !', reg.scope);

        // Vérifie rapidement si une nouvelle version existe après chargement.
        reg.update().catch(() => undefined);

        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent('forfeo-app-update'));
            }
          });
        });
      })
      .catch(err => {
        console.error('❌ Échec de l\'enregistrement du Service Worker :', err);
      });

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.dispatchEvent(new CustomEvent('forfeo-app-update'));
    });
  });
}

initForfeoA3EssentialRuntime();
